import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty as _isEmpty, isUndefined as _isUndefined, toPairs as _toPairs } from 'lodash-es';
import { composeRoleAndFeatureFlagsRules, operators } from 'src/app/shared/helpers/helpers';
import { TemplateService } from 'src/app/templates/services/template.service';

@Pipe({
  name: 'enableTemplateActions'
})
export class EnableTemplateActionsPipe implements PipeTransform {
  constructor(private templateService: TemplateService) {}

  transform(object: any, args: any = {featureFlags: {}, operator: '', role: []}): boolean {
    const {featureFlags, operator, role} = args;
    return this.templateService.computeValue(object, featureFlags, role, operator);
  }
}
